export enum I3pEventsEnum {

    // query start
    geojsonUpdating = 'geojsonUpdating',
    indexPositionUpdating = 'indexPositionUpdating',
    indexDataUpdating = 'indexDataUpdating',
    allDataUpdating = 'allDataUpdating',
    currentEntityUpdating = 'currentEntityUpdating', // on change de current entity

    // query end
    geojsonUpdated = 'geojsonUpdated',
    indexPositionUpdated = 'indexPositionUpdated',
    indexDataUpdated = 'indexDataUpdated',
    allDataUpdated = 'allDataUpdated',
    currentEntityUpdated = 'currentEntityUpdated', // le current entity a été changé (! ne pas confondre avec entityUpdated)

    // entity events
    entityUpdated = 'entityUpdated', // modification des données du current entity (résultat d'une update)
    entityDeleted = 'entityDeleted',
    entityCreated = 'entityCreated',

    entityNotFound = 'entityNotFound',

    // status change
    switchEditMode = 'switchEditMode',

    beforeSaveEntity = 'beforeSaveEntity', // To launch save entity from outside panel component
    beforeSaveEntityFormService = 'beforeSaveEntityFormService', // To launch save entity from outside panel component

    geometryChanged = 'geometryChanged', // geometry is updated in map
    mapFocusOnObject = 'mapFocusOnObject', // event to change bbox of map
    mapFocusBbox = 'mapFocusBbox', // event to change bbox of map
    mapChangeZoom = 'mapChangeZoom',
    resizeMap = 'resizeMap', // event when map width/heigh is changed
}
